/**
 * NjitSearch behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.NjitPrimaryTable.attach}}
   */
  Drupal.behaviors.NjitPrimaryTable = {
    attach: function (context, settings) {
      // For mobile.
      var $primaryTable = $('.primary-table .mobile');
      $('button.more-info-button', $primaryTable).on('click', function (e) {
        var $curRow = $(this).closest('div.table.actions');
        var $moreInfoRow = $curRow.next().find('.more-info-row');

        if ($(this).hasClass('closed')) {
          $(this).removeClass('closed').addClass('opened');
          $curRow.removeClass('closed').addClass('opened');
          $moreInfoRow.removeClass('closed').addClass('opened');
        }
        else {
          $(this).removeClass('opened').addClass('closed');
          $curRow.removeClass('opened').addClass('closed');
          $moreInfoRow.removeClass('opened').addClass('closed');
        }
      });

      // For desktop.
      var $primaryTable = $('.primary-table .desktop');
      $('button.more-info-button', $primaryTable).on('click', function (e) {
        var $curRow = $(this).closest('tr');
        var $moreInfoRow = $curRow.next();

        if ($(this).hasClass('closed')) {
          $(this).removeClass('closed').addClass('opened');
          $curRow.removeClass('closed').addClass('opened');
          $moreInfoRow.removeClass('closed').addClass('opened');
        }
        else {
          $(this).removeClass('opened').addClass('closed');
          $curRow.removeClass('opened').addClass('closed');
          $moreInfoRow.removeClass('opened').addClass('closed');
        }
      });
    }
  };
})(Drupal, jQuery);
